import { Modulo, ModuloUpsert, ModuloForm } from '@models/.';
import { transformArrayConcessionUpsert, transformArrayConcessionForm } from '..';
import { RolModuleEnum } from '@core/enums';

export function transformToData(module: Modulo | null): Modulo | null {
  if (!module) return null;
  
  return {
    ...module,
  };
}

export function transformToForm(module: Modulo): ModuloForm | undefined {
  if (!module) return;
  
  const {
    idModulo: id,
    nombre: name,
    codigo: code,
    concesiones: permissions,
  } = module
  
  return {
    id,
    name,
    code, 
    enabled: false,
    permissions: transformArrayConcessionForm(permissions)
  };
}

export function transformArrayToForm(modules: Modulo[] | undefined): ModuloForm[] {
  const customOrder = [
    RolModuleEnum.Role,
    RolModuleEnum.User,
    RolModuleEnum.Store,
    RolModuleEnum.Account,
  ];
  return ((modules ?? []).map((module) => (transformToForm(module)) as ModuloForm) ?? []).sort((a, b) => {
    const indexA = customOrder.indexOf(a.name as RolModuleEnum);
    const indexB = customOrder.indexOf(b.name as RolModuleEnum);
    
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    return 0;
  });
}

export function transformArrayToUpsert(modulesForm?: ModuloForm[]): ModuloUpsert[] {
  return (modulesForm ?? []).map((module) => {
    const {
      name: nombre,
      code: codigo,
      permissions: concesiones,
    } = module
    
    return {  
      nombre,
      codigo,
      concesiones: transformArrayConcessionUpsert(concesiones),
    };
  })
}